(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("solid-dark", [], factory);
	else if(typeof exports === 'object')
		exports["solid-dark"] = factory();
	else
		root["SurveyTheme"] = factory();
})(this, function() {
return 